export const EXPORT_FORMATS = {
  PDF: 'pdf',
  PNG: 'png',
};

export const getExportActionLabel = (format, isExporting) => {
  if (isExporting) {
    return format === EXPORT_FORMATS.PNG ? 'Generating images...' : 'Generating PDF...';
  }

  return format === EXPORT_FORMATS.PNG ? 'Export Images' : 'Export PDF';
};

export const getExportLoadingLabel = (format) =>
  format === EXPORT_FORMATS.PNG ? 'Generating images...' : 'Generating PDF...';
